import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/event/event_02.jpg")